module.exports = __webpack_public_path__ + "static/media/paintball.8c2881d2.webp";